import React from 'react';
import './ManaCost.css';

interface ManaSymbol {
  symbol: string;
  url: string;
}

interface ManaCostProps {
  manaSymbols?: ManaSymbol[];
  manaCost?: string | null;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const ManaCost: React.FC<ManaCostProps> = ({ 
  manaSymbols, 
  manaCost, 
  size = 'medium',
  className = ''
}) => {
  if (!manaSymbols || manaSymbols.length === 0) {
    if (!manaCost) return null;
    return <span className={`mana-cost-text ${className}`}>{manaCost}</span>;
  }

  const getSizePixels = () => {
    switch (size) {
      case 'small': return 15;
      case 'large': return 24;
      default: return 20;
    }
  };

  const pixels = getSizePixels();

  return (
    <div className={`mana-cost mana-cost-${size} ${className}`}>
      {manaSymbols.map((symbol, index) => (
        <React.Fragment key={index}>
          <img
            src={symbol.url}
            alt={symbol.symbol}
            className="mana-symbol"
            width={pixels}
            height={pixels}
            loading="lazy"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              const fallback = e.currentTarget.nextElementSibling;
              if (fallback) {
                (fallback as HTMLElement).style.display = 'inline';
              }
            }}
          />
          <span className="mana-fallback" style={{ display: 'none' }}>
            {symbol.symbol}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ManaCost;